export default {
    props: {
        chartAreaBackground: {
            type: String,
            default: undefined,
            kComposite: 'chartArea.background'
        }, 
        chartAreaBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'chartArea.border.color'
        }, 
        chartAreaBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'chartArea.border.dashType'
        }, 
        chartAreaBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.border.width'
        }, 
        chartAreaHeight: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.height'
        }, 
        chartAreaMargin: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.margin'
        }, 
        chartAreaMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.margin.bottom'
        }, 
        chartAreaMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.margin.left'
        }, 
        chartAreaMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.margin.right'
        }, 
        chartAreaMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.margin.top'
        }, 
        chartAreaOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.opacity'
        }, 
        chartAreaWidth: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.width'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/ChartArea.js